import React from 'react'
import { Col } from 'reactstrap'
import get from 'lodash/get'
import CalendarNav from '../components/calendar-nav'
import CalendarRangeMode from '../components/calendar-range-mode'

// top bar of my-leave
export default class Top extends React.Component {
  onRangeChange = (range) => {
    this.setState({ range })
    get(this.props, 'onRangeChange')(range)
  }

  render() {
    return (
      <div style={ { display: 'flex', flex: 1, alignItems: 'center', width: '100%' } }>
        <Col>
          <div style={ { display: 'flex', flex: 1 } }>
            <CalendarNav
              onChange={ get(this.props, 'onMomentChange') }
              range={ this.state && this.state.range }
              moment={ get(this.props, 'moment') }
            />
          </div>
        </Col>
        <Col md="3" style={ { marginTop: '-1%' } }>
          {
            get(this.props, 'teamCalendar') &&
            <div style={ { display: 'flex', flex: 1, justifyContent: 'flex-end', float: 'right' } }>
              <CalendarRangeMode onChange={ this.onRangeChange } />
            </div>
          }
        </Col>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/kawari-calendar/team-leave/top.js